import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function EmailThreadDetailCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-sky-200 bg-sky-50 p-4 text-sm text-sky-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-sky-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Thread detail
        </span>
        {typeof answer.message_count === 'number' && (
          <span className="text-xs text-sky-800">
            {answer.message_count} message{answer.message_count === 1 ? '' : 's'}
          </span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
